import { Injectable } from '@angular/core';
import {NeoRestService} from '../neo-rest/neo-rest.service';

export interface OrderFilter {
    paymentStatus?: string[]
    paymentMethod?: string[]
    channel?: string[]
}

export interface OrderParams {
    date?: string
    hotels?: string[]
    orderId?: string
    orderBy?: string
    orderType?: string
    perPage?: number
    page?: number
    filters?: OrderFilter
}

@Injectable()
export class NeoOrderService {

  constructor(
      private _rest: NeoRestService
  ) {}

    /**
     * Devuelve el listado de reservas
     *
     * @param orderOptions
     * @return Un objeto observable
     * */
    searchOrders(orderOptions: OrderParams) {
        return this._rest.postRaw('/order', orderOptions);
    }

    /**
     * Detalles de una reserva
     *
     * @param  orderId Id de la reserva
     * @return Un objeto observable
     * */
    getOrder(orderId: string) {
        return this._rest.get(`/order/${orderId}`);
    }

}



// WEBPACK FOOTER //
// ./src/app/core/services/neo-order/neo-order.service.ts